
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M7.99984 9.33317C8.73622 9.33317 9.33317 8.73622 9.33317 7.99984C9.33317 7.26346 8.73622 6.6665 7.99984 6.6665C7.26346 6.6665 6.6665 7.26346 6.6665 7.99984C6.6665 8.73622 7.26346 9.33317 7.99984 9.33317Z"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.8269 5.17329C11.1988 5.54478 11.4938 5.98593 11.6951 6.47153C11.8964 6.95712 12 7.47763 12 8.00329C12 8.52895 11.8964 9.04946 11.6951 9.53505C11.4938 10.0206 11.1988 10.4618 10.8269 10.8333M5.17354 10.8266C4.80163 10.4551 4.5066 10.014 4.3053 9.52838C4.104 9.04279 4.00039 8.52228 4.00039 7.99662C4.00039 7.47096 4.104 6.95045 4.3053 6.46486C4.5066 5.97927 4.80163 5.53811 5.17354 5.16662M12.7135 3.28662C13.9633 4.53681 14.6654 6.23219 14.6654 7.99995C14.6654 9.76772 13.9633 11.4631 12.7135 12.7133M3.28687 12.7133C2.03706 11.4631 1.33496 9.76772 1.33496 7.99995C1.33496 6.23219 2.03706 4.53681 3.28687 3.28662"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);


export default Icon
